import { Component, OnInit } from '@angular/core';
import { AddonsService } from '../../../shared/packs/addons.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { url } from '../../../shared/urls/url';
import { AuthenticationService } from '../../../core/authentication/Authentication.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-pack',
  templateUrl: './pack.component.html',
  styleUrls: ['./pack.component.scss']
})
export class PackComponent implements OnInit {
  add = new AddonsService('pack prueba', 3, 3, 3, 3, 3, 30);
  arrepack: Array<AddonsService>;
  narrepack: Array<number>;
  pack: AddonsService;
  packseleccionado: any;
  idCuenta: any;
  idCustomer: any;
  guid: any;
  restantes: any;
  arrepackcomprado: Array<any>;
  NamePlan;
  //narrepackcomprado:Array<number>;
  constructor(private user: url, private http: HttpClient, private auth: AuthenticationService,
    private router: Router, private translate: TranslateService) {
      this.packseleccionado = 0;
      this.NamePlan = localStorage.getItem('productNamePlan');
    /* this.guid = localStorage.getItem('uid');
     this.http.get(this.user.apiback+'/getaccount?id='+this.guid).subscribe(y=>{ 
       var w=JSON.stringify(y); 
          var oj = JSON.parse(w);
        
         this.idCuenta = oj.idCuenta;
         this.idCustomer = oj.idCustomer;
         const url6 = this.user.apiback+"VerificacionesRestantes?="+this.idCuenta;
         this.http.get(url6, {responseType: 'text'}).subscribe(x=>{ 
           this.restantes = x;
 
         });
 
         this.arrepackcomprado = new Array<any>();
     this.http.get(this.user.apiback+'/getPackCuenta?id='+this.idCuenta).subscribe(y=>{ 
         var w=JSON.stringify(y); 
            var oj = JSON.parse(w);       
           oj.forEach(x => {       
             this.arrepackcomprado.push(x);      
           });
           
       }) 
         //console.log(this.idCuenta);
     }) */

  }

  ngOnInit() {
    // this.narrepack = new Array<number>();

    this.translate.use(localStorage.getItem('language'));

    this.arrepack = new Array<AddonsService>();
    this.http.get(this.user.apiback + '/getpack').subscribe(y => {
      var w = JSON.stringify(y);
      var oj = JSON.parse(w);
      oj.forEach(x => {
        var metadata = JSON.parse(x.metadataPack)
        var nombre = x.name;
        var precio = metadata.precio;
        var cupos = metadata.verificaciones;
        this.pack = new AddonsService(nombre, precio, 0, cupos, 0, 0, 0);
        this.arrepack.push(this.pack);
      });

    })

    this.guid = localStorage.getItem('uid');
    this.http.get(this.user.apiback + '/getaccount?id=' + this.guid).subscribe(y => {
      var w = JSON.stringify(y);
      var oj = JSON.parse(w);

      this.idCuenta = oj.idCuenta;
      this.idCustomer = oj.idCustomer;
      const url6 = this.user.apiback + "/VerificacionesRestantes?=" + this.idCuenta;
      this.http.get(url6, { responseType: 'text' }).subscribe(x => {
        this.restantes = x;

      });

      this.arrepackcomprado = new Array<any>();
      this.http.get(this.user.apiback + '/getPackCuenta?id=' + this.idCuenta).subscribe(y => {
        var w = JSON.stringify(y);
        var oj = JSON.parse(w);
        oj.forEach(x => {
          this.arrepackcomprado.push(x);
        });

      })
      //console.log(this.idCuenta);
    })

  }

  Comprar() {



    var pack = this.arrepack.find(x => x.nombre == this.packseleccionado);
    var precio = parseFloat(pack.precio) * 100;
    const url1 = this.user.apiphp + "?comprarpack=true&nombre=" + this.packseleccionado + "&precio=" + precio + "&customer=" + this.idCustomer;
    //const url2 = this.user.apiback + "/registerPackCuenta?idcuenta=" + this.idCuenta + "&num=" + pack.cupos;
    const url2 = this.user.apiback + "/registerPackCuenta";

    const dataX = {
      IDCuenta: this.idCuenta,
      Verificaciones: pack.cupos,
/*       StartDate: Date.now(),
      ExpirationDate: Date.now() */
    };

    this.http.get(url1, { responseType: 'text' }).subscribe(x => {
      // var j=JSON.parse(x.toString());
      // console.log(x);
      this.http.post(url2, dataX).subscribe(y => {
        const w = JSON.stringify(y);
        const oj = JSON.parse(w);
        this.router.navigate(['/agradecimiento', 'Gracias por adquirir el Pack', pack.cupos + ' Verificaciones']);
      });
      /* this.http.get(url2, { responseType: 'text' }).subscribe(z => {
        var jm = JSON.parse(z.toString());
        console.log(jm);
        this.router.navigate(['/agradecimiento', 'Gracias adquirir nuevo Pack', pack.cupos + ' Verificaciones']);
      }) */
    });

  }

}
